<template lang="pug">
.container
  .columns
    .column
      form(onsubmit="event.preventDefault()")
        b-field
          b-autocomplete(
            ref="input_autocomplete",
            @keyup.native="(evt) => { evt.keyCode == 13 ? blurAutoComplete() : null; }",
            :value="searchingProfName",
            expanded,
            placeholder="Search with professor name",
            :data="filteredProfNamesAutoComplete",
            @input="(value) => { setSearchingProfName(value); }"
          )
          b-button(
            @click="() => { search(); }",
            :loading="isFetching",
            native-type="submit",
            type="is-primary",
            icon-left="search"
          ) Search
      .has-text-centered.has-text-primary(
        v-if="!searchedFirstTime && !isFetching",
        style={ 'margin-top': '15px' }
      )
        p Search with author's first name and last name. For example, "Jack Dawson", "Rose Bukater" ..

  .level(v-if="searchedFirstTime")
    //search options
    .level-left
      .level-item
        SearchOptions
    //record selection and save
    .level-right
      .level-item
        b-button(
          @click="uiSelectAllRecords",
          :disabled="papers.length === 0",
          icon-left="mouse-pointer",
          type="is-primary"
        )
          | Select All Records
      .level-item
        b-button(
          @click="openSelectCollectionModal",
          :disabled="selectedPapersLength === 0",
          icon-left="cloud-upload-alt",
          type="is-success"
        )
          | Save Selected Record(s)

  div(v-if="isFetching")
    progress.progress.is-small.is-primary(max="100")
  div(v-else)
    .level(v-if="searchedFirstTime")
      .level-item
        .content
          h5 Found {{ papers.length }} record(s)
    PaperRecord(
      v-for="(item, index) in papers",
      :key="item.id",
      :id="item.id",
      :index="index + 1",
      :title="item.title",
      :authors="item.authors",
      :presentPlace="item.presentPlace",
      :year="item.year",
      :website="item.website",
      :cite="item.cite",
      :selected="item.selected",
      :linkToCitation="item.linkToCitation",
      :linkToProfessor="item.linkToProfessor",
      :apa="item.apa",
      :bibtex="item.bibtex"
    )
</template>
<script>
import PaperRecord from "./PaperRecord";
import SearchOptions from "./SearchOptions";
import SelectCollectionModal from "../collections/SelectCollectionModal.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import {
  loadProfNamesAutoComplete,
  addSearchingProfName,
} from "../../../util/profNamesAutoComplete";

export default {
  components: { PaperRecord, SearchOptions, SelectCollectionModal },

  created() {
    this.profNamesAutoComplete = loadProfNamesAutoComplete(this.username);
  },

  data: () => ({
    searchedFirstTime: false,
    profNamesAutoComplete: [],
  }),

  computed: {
    ...mapGetters("fetchPaper", ["papers", "selectedPapersLength"]),
    ...mapState("fetchPaper", {
      isFetching: (state) => state.isFetching,
      searchingProfName: (state) => state.searchingProfName,
    }),
    ...mapState("saveRecord", {
      isSelectCollectionModalOpened: (state) => state.isModalOpened,
    }),
    ...mapState("authentication", {
      username: (s) => s.userData?.username,
    }),
    filteredProfNamesAutoComplete() {
      return this.profNamesAutoComplete.filter((option) => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.searchingProfName.toLowerCase()) >= 0
        );
      });
    },
  },

  methods: {
    ...mapActions("fetchPaper", ["fetchPapers"]),
    async search() {
      this.setSearchingProfName(
        preprocessSearchingProfName(this.searchingProfName)
      );

      addSearchingProfName(this.username, this.searchingProfName);
      //validate searching prof name
      if (this.searchingProfName.split(" ").length !== 2) {
        this.openErrorMessageBox(
          'Please provide author\'s first name, a space, and last name.\nFor example "John Lennon"'
        );
        return;
      }

      this.profNamesAutoComplete = loadProfNamesAutoComplete(this.username);

      const resp = await this.fetchPapers();
      this.searchedFirstTime = true;
      if (resp.status === "success") {
        this.openSuccessSnackbar("Searching is successful");
      } else {
        this.openErrorMessageBox(
          resp.message ?? "Searching is error! Please try again later"
        );
      }
    },
    ...mapMutations("fetchPaper", ["setSearchingProfName", "selectAllRecords"]),
    ...mapMutations("saveRecord", {
      openSelectCollectionModal: "openModal",
    }),
    uiSelectAllRecords() {
      this.selectAllRecords();
    },
    blurAutoComplete() {
      this.$refs.input_autocomplete.setSelected(
        preprocessSearchingProfName(this.searchingProfName)
      );
    },
  },
};

const preprocessSearchingProfName = (searchingProfName) => {
  //trim space
  searchingProfName = searchingProfName.trim();
  //capitalize firstname lastname
  const splited = searchingProfName.split(" ");
  for (let i = 0; i < splited.length; i++) {
    splited[i] = splited[i].charAt(0).toUpperCase() + splited[i].slice(1);
  }
  return splited.join(" ");
};
</script>
